function rotateLeft(value, shift) {
  return (value << shift) | (value >>> (32 - shift));
}

function addUnsigned(x, y) {
  const x4 = x & 0x40000000;
  const y4 = y & 0x40000000;
  const x8 = x & 0x80000000;
  const y8 = y & 0x80000000;
  const result = (x & 0x3fffffff) + (y & 0x3fffffff);
  if (x4 & y4) {
    return result ^ 0x80000000 ^ x8 ^ y8;
  }
  if (x4 | y4) {
    if (result & 0x40000000) {
      return result ^ 0xc0000000 ^ x8 ^ y8;
    }
    return result ^ 0x40000000 ^ x8 ^ y8;
  }
  return result ^ x8 ^ y8;
}

function f(x, y, z) {
  return (x & y) | (~x & z);
}

function g(x, y, z) {
  return (x & z) | (y & ~z);
}

function h(x, y, z) {
  return x ^ y ^ z;
}

function i(x, y, z) {
  return y ^ (x | ~z);
}

function convertToWordArray(str) {
  const lWordCount = [];
  let messageLength = str.length;
  let numberOfWordsTempOne = messageLength + 8;
  let numberOfWordsTempTwo = (numberOfWordsTempOne - (numberOfWordsTempOne % 64)) / 64;
  let numberOfWords = (numberOfWordsTempTwo + 1) * 16;
  for (let i = 0; i < numberOfWords; i++) {
    lWordCount[i] = 0;
  }
  let bytePosition = 0;
  let byteCount = 0;
  while (byteCount < messageLength) {
    let wordCount = (byteCount - (byteCount % 4)) / 4;
    bytePosition = (byteCount % 4) * 8;
    lWordCount[wordCount] |= str.charCodeAt(byteCount) << bytePosition;
    byteCount++;
  }
  let wordCount = (byteCount - (byteCount % 4)) / 4;
  bytePosition = (byteCount % 4) * 8;
  lWordCount[wordCount] |= 0x80 << bytePosition;
  lWordCount[numberOfWords - 2] = messageLength << 3;
  lWordCount[numberOfWords - 1] = messageLength >>> 29;
  return lWordCount;
}

function wordToHex(value) {
  let hex = "";
  for (let i = 0; i <= 3; i++) {
    const byte = (value >>> (i * 8)) & 255;
    const temp = "0" + byte.toString(16);
    hex += temp.slice(-2);
  }
  return hex;
}

export function md5(value) {
  const x = convertToWordArray(unescape(encodeURIComponent(String(value || ""))));
  let a = 0x67452301;
  let b = 0xefcdab89;
  let c = 0x98badcfe;
  let d = 0x10325476;

  for (let k = 0; k < x.length; k += 16) {
    const aa = a;
    const bb = b;
    const cc = c;
    const dd = d;

    a = addUnsigned(a, addUnsigned(addUnsigned(f(b, c, d), x[k + 0]), 0xd76aa478));
    a = addUnsigned(rotateLeft(a, 7), b);
    d = addUnsigned(d, addUnsigned(addUnsigned(f(a, b, c), x[k + 1]), 0xe8c7b756));
    d = addUnsigned(rotateLeft(d, 12), a);
    c = addUnsigned(c, addUnsigned(addUnsigned(f(d, a, b), x[k + 2]), 0x242070db));
    c = addUnsigned(rotateLeft(c, 17), d);
    b = addUnsigned(b, addUnsigned(addUnsigned(f(c, d, a), x[k + 3]), 0xc1bdceee));
    b = addUnsigned(rotateLeft(b, 22), c);
    a = addUnsigned(a, addUnsigned(addUnsigned(f(b, c, d), x[k + 4]), 0xf57c0faf));
    a = addUnsigned(rotateLeft(a, 7), b);
    d = addUnsigned(d, addUnsigned(addUnsigned(f(a, b, c), x[k + 5]), 0x4787c62a));
    d = addUnsigned(rotateLeft(d, 12), a);
    c = addUnsigned(c, addUnsigned(addUnsigned(f(d, a, b), x[k + 6]), 0xa8304613));
    c = addUnsigned(rotateLeft(c, 17), d);
    b = addUnsigned(b, addUnsigned(addUnsigned(f(c, d, a), x[k + 7]), 0xfd469501));
    b = addUnsigned(rotateLeft(b, 22), c);
    a = addUnsigned(a, addUnsigned(addUnsigned(f(b, c, d), x[k + 8]), 0x698098d8));
    a = addUnsigned(rotateLeft(a, 7), b);
    d = addUnsigned(d, addUnsigned(addUnsigned(f(a, b, c), x[k + 9]), 0x8b44f7af));
    d = addUnsigned(rotateLeft(d, 12), a);
    c = addUnsigned(c, addUnsigned(addUnsigned(f(d, a, b), x[k + 10]), 0xffff5bb1));
    c = addUnsigned(rotateLeft(c, 17), d);
    b = addUnsigned(b, addUnsigned(addUnsigned(f(c, d, a), x[k + 11]), 0x895cd7be));
    b = addUnsigned(rotateLeft(b, 22), c);
    a = addUnsigned(a, addUnsigned(addUnsigned(f(b, c, d), x[k + 12]), 0x6b901122));
    a = addUnsigned(rotateLeft(a, 7), b);
    d = addUnsigned(d, addUnsigned(addUnsigned(f(a, b, c), x[k + 13]), 0xfd987193));
    d = addUnsigned(rotateLeft(d, 12), a);
    c = addUnsigned(c, addUnsigned(addUnsigned(f(d, a, b), x[k + 14]), 0xa679438e));
    c = addUnsigned(rotateLeft(c, 17), d);
    b = addUnsigned(b, addUnsigned(addUnsigned(f(c, d, a), x[k + 15]), 0x49b40821));
    b = addUnsigned(rotateLeft(b, 22), c);

    a = addUnsigned(a, addUnsigned(addUnsigned(g(b, c, d), x[k + 1]), 0xf61e2562));
    a = addUnsigned(rotateLeft(a, 5), b);
    d = addUnsigned(d, addUnsigned(addUnsigned(g(a, b, c), x[k + 6]), 0xc040b340));
    d = addUnsigned(rotateLeft(d, 9), a);
    c = addUnsigned(c, addUnsigned(addUnsigned(g(d, a, b), x[k + 11]), 0x265e5a51));
    c = addUnsigned(rotateLeft(c, 14), d);
    b = addUnsigned(b, addUnsigned(addUnsigned(g(c, d, a), x[k + 0]), 0xe9b6c7aa));
    b = addUnsigned(rotateLeft(b, 20), c);
    a = addUnsigned(a, addUnsigned(addUnsigned(g(b, c, d), x[k + 5]), 0xd62f105d));
    a = addUnsigned(rotateLeft(a, 5), b);
    d = addUnsigned(d, addUnsigned(addUnsigned(g(a, b, c), x[k + 10]), 0x02441453));
    d = addUnsigned(rotateLeft(d, 9), a);
    c = addUnsigned(c, addUnsigned(addUnsigned(g(d, a, b), x[k + 15]), 0xd8a1e681));
    c = addUnsigned(rotateLeft(c, 14), d);
    b = addUnsigned(b, addUnsigned(addUnsigned(g(c, d, a), x[k + 4]), 0xe7d3fbc8));
    b = addUnsigned(rotateLeft(b, 20), c);
    a = addUnsigned(a, addUnsigned(addUnsigned(g(b, c, d), x[k + 9]), 0x21e1cde6));
    a = addUnsigned(rotateLeft(a, 5), b);
    d = addUnsigned(d, addUnsigned(addUnsigned(g(a, b, c), x[k + 14]), 0xc33707d6));
    d = addUnsigned(rotateLeft(d, 9), a);
    c = addUnsigned(c, addUnsigned(addUnsigned(g(d, a, b), x[k + 3]), 0xf4d50d87));
    c = addUnsigned(rotateLeft(c, 14), d);
    b = addUnsigned(b, addUnsigned(addUnsigned(g(c, d, a), x[k + 8]), 0x455a14ed));
    b = addUnsigned(rotateLeft(b, 20), c);
    a = addUnsigned(a, addUnsigned(addUnsigned(g(b, c, d), x[k + 13]), 0xa9e3e905));
    a = addUnsigned(rotateLeft(a, 5), b);
    d = addUnsigned(d, addUnsigned(addUnsigned(g(a, b, c), x[k + 2]), 0xfcefa3f8));
    d = addUnsigned(rotateLeft(d, 9), a);
    c = addUnsigned(c, addUnsigned(addUnsigned(g(d, a, b), x[k + 7]), 0x676f02d9));
    c = addUnsigned(rotateLeft(c, 14), d);
    b = addUnsigned(b, addUnsigned(addUnsigned(g(c, d, a), x[k + 12]), 0x8d2a4c8a));
    b = addUnsigned(rotateLeft(b, 20), c);

    a = addUnsigned(a, addUnsigned(addUnsigned(h(b, c, d), x[k + 5]), 0xfffa3942));
    a = addUnsigned(rotateLeft(a, 4), b);
    d = addUnsigned(d, addUnsigned(addUnsigned(h(a, b, c), x[k + 8]), 0x8771f681));
    d = addUnsigned(rotateLeft(d, 11), a);
    c = addUnsigned(c, addUnsigned(addUnsigned(h(d, a, b), x[k + 11]), 0x6d9d6122));
    c = addUnsigned(rotateLeft(c, 16), d);
    b = addUnsigned(b, addUnsigned(addUnsigned(h(c, d, a), x[k + 14]), 0xfde5380c));
    b = addUnsigned(rotateLeft(b, 23), c);
    a = addUnsigned(a, addUnsigned(addUnsigned(h(b, c, d), x[k + 1]), 0xa4beea44));
    a = addUnsigned(rotateLeft(a, 4), b);
    d = addUnsigned(d, addUnsigned(addUnsigned(h(a, b, c), x[k + 4]), 0x4bdecfa9));
    d = addUnsigned(rotateLeft(d, 11), a);
    c = addUnsigned(c, addUnsigned(addUnsigned(h(d, a, b), x[k + 7]), 0xf6bb4b60));
    c = addUnsigned(rotateLeft(c, 16), d);
    b = addUnsigned(b, addUnsigned(addUnsigned(h(c, d, a), x[k + 10]), 0xbebfbc70));
    b = addUnsigned(rotateLeft(b, 23), c);
    a = addUnsigned(a, addUnsigned(addUnsigned(h(b, c, d), x[k + 13]), 0x289b7ec6));
    a = addUnsigned(rotateLeft(a, 4), b);
    d = addUnsigned(d, addUnsigned(addUnsigned(h(a, b, c), x[k + 0]), 0xeaa127fa));
    d = addUnsigned(rotateLeft(d, 11), a);
    c = addUnsigned(c, addUnsigned(addUnsigned(h(d, a, b), x[k + 3]), 0xd4ef3085));
    c = addUnsigned(rotateLeft(c, 16), d);
    b = addUnsigned(b, addUnsigned(addUnsigned(h(c, d, a), x[k + 6]), 0x04881d05));
    b = addUnsigned(rotateLeft(b, 23), c);
    a = addUnsigned(a, addUnsigned(addUnsigned(h(b, c, d), x[k + 9]), 0xd9d4d039));
    a = addUnsigned(rotateLeft(a, 4), b);
    d = addUnsigned(d, addUnsigned(addUnsigned(h(a, b, c), x[k + 12]), 0xe6db99e5));
    d = addUnsigned(rotateLeft(d, 11), a);
    c = addUnsigned(c, addUnsigned(addUnsigned(h(d, a, b), x[k + 15]), 0x1fa27cf8));
    c = addUnsigned(rotateLeft(c, 16), d);
    b = addUnsigned(b, addUnsigned(addUnsigned(h(c, d, a), x[k + 2]), 0xc4ac5665));
    b = addUnsigned(rotateLeft(b, 23), c);

    a = addUnsigned(a, addUnsigned(addUnsigned(i(b, c, d), x[k + 0]), 0xf4292244));
    a = addUnsigned(rotateLeft(a, 6), b);
    d = addUnsigned(d, addUnsigned(addUnsigned(i(a, b, c), x[k + 7]), 0x432aff97));
    d = addUnsigned(rotateLeft(d, 10), a);
    c = addUnsigned(c, addUnsigned(addUnsigned(i(d, a, b), x[k + 14]), 0xab9423a7));
    c = addUnsigned(rotateLeft(c, 15), d);
    b = addUnsigned(b, addUnsigned(addUnsigned(i(c, d, a), x[k + 5]), 0xfc93a039));
    b = addUnsigned(rotateLeft(b, 21), c);
    a = addUnsigned(a, addUnsigned(addUnsigned(i(b, c, d), x[k + 12]), 0x655b59c3));
    a = addUnsigned(rotateLeft(a, 6), b);
    d = addUnsigned(d, addUnsigned(addUnsigned(i(a, b, c), x[k + 3]), 0x8f0ccc92));
    d = addUnsigned(rotateLeft(d, 10), a);
    c = addUnsigned(c, addUnsigned(addUnsigned(i(d, a, b), x[k + 10]), 0xffeff47d));
    c = addUnsigned(rotateLeft(c, 15), d);
    b = addUnsigned(b, addUnsigned(addUnsigned(i(c, d, a), x[k + 1]), 0x85845dd1));
    b = addUnsigned(rotateLeft(b, 21), c);
    a = addUnsigned(a, addUnsigned(addUnsigned(i(b, c, d), x[k + 8]), 0x6fa87e4f));
    a = addUnsigned(rotateLeft(a, 6), b);
    d = addUnsigned(d, addUnsigned(addUnsigned(i(a, b, c), x[k + 15]), 0xfe2ce6e0));
    d = addUnsigned(rotateLeft(d, 10), a);
    c = addUnsigned(c, addUnsigned(addUnsigned(i(d, a, b), x[k + 6]), 0xa3014314));
    c = addUnsigned(rotateLeft(c, 15), d);
    b = addUnsigned(b, addUnsigned(addUnsigned(i(c, d, a), x[k + 13]), 0x4e0811a1));
    b = addUnsigned(rotateLeft(b, 21), c);
    a = addUnsigned(a, addUnsigned(addUnsigned(i(b, c, d), x[k + 4]), 0xf7537e82));
    a = addUnsigned(rotateLeft(a, 6), b);
    d = addUnsigned(d, addUnsigned(addUnsigned(i(a, b, c), x[k + 11]), 0xbd3af235));
    d = addUnsigned(rotateLeft(d, 10), a);
    c = addUnsigned(c, addUnsigned(addUnsigned(i(d, a, b), x[k + 2]), 0x2ad7d2bb));
    c = addUnsigned(rotateLeft(c, 15), d);
    b = addUnsigned(b, addUnsigned(addUnsigned(i(c, d, a), x[k + 9]), 0xeb86d391));
    b = addUnsigned(rotateLeft(b, 21), c);

    a = addUnsigned(a, aa);
    b = addUnsigned(b, bb);
    c = addUnsigned(c, cc);
    d = addUnsigned(d, dd);
  }

  return (wordToHex(a) + wordToHex(b) + wordToHex(c) + wordToHex(d)).toLowerCase();
}
